export enum AddButtonRedirect {
    CATALOG = "catalog",
    SUMMARY_PAGE = "summary_page",
}